import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'PriceListItem',
    returnTo: 'Domains'
  }),
  created() {
    const domainID = +this.$route.params.domainID;
    this.$store.dispatch('country/getItems');
    this.$store.dispatch('culture/getItems', { query: { domainID: domainID } });
    this.$store.dispatch('glAccount/getItems', { query: { domainID: domainID } });
  },
  methods: {
    getDependencies(data) {
      return [];
    },
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
